<template>
  <div class="outcomes-report-container">
    <slot />
  </div>
</template>

<style lang="css" scoped>
.outcomes-report-container {
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: left;
  align-items: flex-start;
  background-color: white;
  border-radius: 25px;
  padding: 2rem;
}
</style>
